import baseOC from "icfrontendbase";
import { buildEmptyObjectContainer } from "icfrontendbase";

import axios from "axios";
import AxiosRequestAgent from "./requestModule/agent/AxiosRequestAgent";
import AxiosRequestAgentResBodyDecorator from "./requestModule/agent/decorator/AxiosRequestAgentResBodyDecorator";
import RequestModule from "./requestModule/RequestModule";

import QueryParamStringStrategy from "./apiAgent/QueryParamStringStrategy";
import BizApiAgent from "./apiAgent/bizApiAgent/BizApiAgent";
import ApiAgentReqInFlightDecorator from "./apiAgent/ApiAgentReqInFlightDecorator";
import BizApiAgentErrorConverterDecorator from "./apiAgent/bizApiAgent/errorConverter/BizApiAgentErrorConverterDecorator";
import BizApiAxiosErrorConverterStrategy from "./apiAgent/bizApiAgent/errorConverter/BizApiAxiosErrorConverterStrategy";
import BizApiErrorInterpreter from "./apiAgent/bizApiAgent/errorConverter/BizApiErrorInterpreter";
import BizApiClient from "./apiClient/bizApiClient/BizApiClient";

const buildOC = () => {
    const libOC = buildEmptyObjectContainer();

    const  _build_ConfigStorage = (container, parent) => {
        const configStorage = baseOC.get("ConfigStorage");
        configStorage.set("bizapi_url_base", "/business/proxy/product")
        return configStorage;
    }
    libOC.set("ConfigStorage", _build_ConfigStorage);

    const _build_QueryParamStringStrategy = (container, parent) => {        
        return new QueryParamStringStrategy();
    }
    libOC.set("QueryParamStringStrategy", _build_QueryParamStringStrategy);

    const _build_AxiosRequestModule = (container, parent) => {        
        return new RequestModule(
            new AxiosRequestAgentResBodyDecorator(
                new AxiosRequestAgent(axios)
            )
        );
    }
    libOC.set("AxiosRequestModule", _build_AxiosRequestModule);

    const _build_BizApiAgent = (container, parent) => {        
        return new ApiAgentReqInFlightDecorator(
            new BizApiAgentErrorConverterDecorator(
                new BizApiAgent(
                    container.get("AxiosRequestModule"),
                    container.get("ConfigStorage").get("bizapi_url_base"),
                    container.get("QueryParamStringStrategy")
                ),
                new BizApiAxiosErrorConverterStrategy(
                    baseOC.get("Getter")
                )
            ),
            container.get("QueryParamStringStrategy")
        );
    }
    libOC.set("BizApiAgent", _build_BizApiAgent);

    const _build_BizApiClient = (container, parent) => {        
        return new BizApiClient(
            container.get("BizApiAgent")
        );
    }
    libOC.set("BizApiClient", _build_BizApiClient);

    const _build_BizApiErrorInterpreter = (container, parent) => {        
        return new BizApiErrorInterpreter(
            baseOC.get("Getter")
        );
    }
    libOC.set("BizApiErrorInterpreter", _build_BizApiErrorInterpreter);

    return libOC;
}

export default buildOC;
